import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import {
  fetchShiftListing,
  reStateFilters,
  setShiftListingLoading,
  showShiftListingFilterModal,
  updateShiftListingFilters,
  updateShiftListingPagination,
} from "@/reducers/clientdashboard";
import { fetchFiltersData } from "@/reducers/clientscandidates";

import CalendarFilter from "../../ListingFilters/CalendarFilter";
import ComplianceStatusFilter from "../../ListingFilters/ComplianceStatusFilter";
import DropDownFilter from "../../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../../ListingFilters/FilterModalTop";
import TextFieldFilter from "../../ListingFilters/TextFieldFilter";

const ShiftListingFilterModal = () => {
  const dispatch = useDispatch();
  const {
    rightSideShiftScheduleFilter,
    showShiftListingFilters,
    shiftListingPagination,
  } = useSelector((state) => state.clientDashboard);
  const { filterLists } = useSelector((state) => state.clientsCandidates);
  /**
   * A function to handle closing with an optional parameter.
   *
   * @param {boolean} fromBtn - indicates if the function is called from a button
   * @return {void}
   */
  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showShiftListingFilterModal(false));
  };
  useEffect(() => {
    dispatch(fetchFiltersData());
    return () => {
      dispatch(showShiftListingFilterModal(false));
    };
  }, []);
  /**
   * Function to handle the apply action.
   */
  const handleApply = () => {
    dispatch(setShiftListingLoading(true));
    dispatch(
      updateShiftListingPagination({
        ...shiftListingPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchShiftListing());
    handleClose();
  };
  /**
   * This function handles the reset action by dispatching updates to filters, setting applied candidates loading, updating pagination, fetching applied candidates, and closing the current modal.
   */
  const handleReset = () => {
    dispatch(updateShiftListingFilters());
    dispatch(setShiftListingLoading(true));
    dispatch(
      updateShiftListingPagination({
        ...shiftListingPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchShiftListing());
    handleClose();
  };
  return (
    <ModalPopUp
      show={showShiftListingFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose();
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[12px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({ candidateReferenceNo: value }),
                );
              }}
              label="Candidate Reference No."
              value={rightSideShiftScheduleFilter.candidateReferenceNo}
              filterId="candidateReferenceNo"
              placeholder="Enter Reference No."
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({ contractReferenceNo: value }),
                );
              }}
              label="Contract Reference No."
              value={rightSideShiftScheduleFilter.contractReferenceNo}
              filterId="contractReferenceNo"
              placeholder="Enter Reference No."
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateShiftListingFilters({ candidateName: value }));
              }}
              label="Candidate Name"
              value={rightSideShiftScheduleFilter.candidateName}
              filterId="candidateName"
              placeholder="Enter Candidate Name"
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({ candidateLicenseNo: value }),
                );
              }}
              label="Prof. Registration No."
              value={rightSideShiftScheduleFilter.candidateLicenseNo}
              filterId="candidateLicenseNo"
              placeholder="GMC/NMC/GPhC"
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({ candidatePhoneNumber: value }),
                );
              }}
              label="Candidate Phone Number"
              value={rightSideShiftScheduleFilter.candidatePhoneNumber}
              filterId="candidatePhoneNumber"
              placeholder="Enter Candidate Phone Number"
            />
            <ComplianceStatusFilter
              value={rightSideShiftScheduleFilter.complianceStatus}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({ complianceStatus: value }),
                );
              }}
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allRoles?.length > 0
                  ? filterLists?.allRoles
                  : []
              } // this is the list of roles
              id="candidateRole"
              label="Role"
              placeholder="Select Role"
              value={rightSideShiftScheduleFilter.candidateRole} // selected role
              handleChange={(value) => {
                dispatch(updateShiftListingFilters({ candidateRole: value }));
              }} // function to handle change of role
            />
          </div>
          <div className="_filter_calendar _shift_listing_filter_calendar">
            <CalendarFilter
              label="Shift Dates (From - To)"
              dateFrom={rightSideShiftScheduleFilter.shiftDateFrom}
              dateTo={rightSideShiftScheduleFilter.shiftDateTo}
              handleChange={(value) => {
                dispatch(
                  updateShiftListingFilters({
                    shiftDateFrom: value.dateFrom,
                    shiftDateTo: value.dateTo,
                  }),
                );
              }}
              disabledDate={(current) => {
                // enable current month only
                return (
                  (current && current > dayjs().endOf("month")) ||
                  current < dayjs().startOf("month")
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};

export default ShiftListingFilterModal;
